// extracted by mini-css-extract-plugin
export var customFont = "Header-module--customFont--6a324";
export var item = "Header-module--item--80dc2";
export var list = "Header-module--list--11cfe";
export var logo = "Header-module--logo--edb3a";
export var mobileNavbar = "Header-module--mobileNavbar--dadf7";
export var root = "Header-module--root--6d142";